/** Pure helpers for the account's Test orders tab. */
import type { OrderSampleStatusCount, OrderSampleStore } from '@/types';

/** machine keeps a sheet 24 hours. */
export const SHEET_LIFETIME_MS = 24 * 60 * 60 * 1000;

const IST = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kolkata',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
});

/** "16 Oct, 15:03 IST". The team reads times in IST. */
export const formatIst = (iso: string | number) => `${IST.format(new Date(iso))} IST`;

export const storeLabel = (store: OrderSampleStore) =>
  `${store.brandName ?? 'No brand'} · ${store.shop}.myshopify.com`;

/** Took every usable order the store had, and that was fewer than the other statuses got. */
export const isShort = (status: OrderSampleStatusCount, statuses: OrderSampleStatusCount[]) => {
  const most = Math.max(0, ...statuses.map((each) => each.picked));
  return status.picked > 0 && status.picked === status.eligible && status.picked < most;
};
